import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';

import { wideWidth } from '~src/settings/styles/CommonStyles';

var customDomainSizeUnit = 5;
var customDomainSpaceUnit = customDomainSizeUnit;

export const labelTextStyle: NestedCSSProperties = {
    paddingTop: TabStyles.Spacing.MediumSpace,
  };

export const defaultTextAlignment: React.CSSProperties = {
  textAlign: 'right'
};

export const warningTextStyle: React.CSSProperties = {
  ...defaultTextAlignment,
  color: 'red',
  display: 'flex',
  alignItems: 'center'
};

export const clockIconStyle = style({
    ...labelTextStyle,
    paddingRight:  TabStyles.Spacing.SmallSpace
  });

export const intermediateDomainwarningStyle = style({
  ...labelTextStyle,
    color: 'red'
  });

export const intermediateDomainTextStyle = style({
    ...labelTextStyle,
  });

export const successIconStyle = style({
    width: 30,
    height: 32,
    marginTop: TabStyles.Spacing.LargeSpace,
  });

export const uploadSslDefaultMarginStyle: React.CSSProperties = {
    marginTop: TabStyles.Spacing.LargeSpace + customDomainSpaceUnit+3
  };

export const customDomainSubHeaderStyle = {
    ...uploadSslDefaultMarginStyle,
    paddingLeft: TabStyles.Spacing.MediumSpace,
    fontSize: TabStyles.Typography.Sizing.Large
  };

  export const uploadSslSubHeaderStyle = style({
    ...uploadSslDefaultMarginStyle,
    marginBottom: customDomainSpaceUnit+3,
    fontSize: TabStyles.Typography.Sizing.Large
  });

  export const replaceSslSubHeaderStyle = {
    ...uploadSslDefaultMarginStyle,
    fontSize: TabStyles.Typography.Sizing.Large
  };

  export const replaceSslParentContainerStyle: React.CSSProperties = {
    marginTop: customDomainSpaceUnit + 3
  };

  export const uploadSslParentContainerStyle: React.CSSProperties = {
    marginLeft: '29px'
  };

  export const fileUploadContainerStyle: React.CSSProperties = {
    marginTop: customDomainSpaceUnit
  };

  export const customDomainContentStyle = style({
    marginLeft: TabStyles.Spacing.MediumSpace + customDomainSpaceUnit*3,
    display: 'flex',
    position: 'relative'
  });

  export const customDomainButtonStyle = style({
    position: 'absolute',
    bottom: 0,
    right: 0
  });

export const customDomainHeaderContainer = style({
    display: 'flex'
  });

  export const configuredSettingHeaderStyle = style({
    fontSize: TabStyles.Typography.Sizing.Large
  });

  export const configuredSettingAlertStyle = style({
    marginBottom: TabStyles.Spacing.LargeSpace,
  });

  export const configuredSettingContentStyle = style({
    marginTop: TabStyles.Spacing.MediumSpace,
  });

  export const configuredSettingValueStyle = style({
    marginTop: TabStyles.Spacing.SmallSpace,
    display: 'flex',
    position: 'relative'
  });

  export const configuredSettingButtonStyle = style({
    marginRight: TabStyles.Spacing.MediumSpace,
  });

  export const submitButtonStyle = style({
    position: 'relative',
    marginTop: TabStyles.Spacing.MediumSpace,
  });

  export const uploadSslLabelStyle = style({
    display: 'flex',
    flexDirection: 'column',
  });

  export const progressIconContent = style({
    fontFamily: 'Benton Sans',
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 24,
    textAlign: 'center',
    color: '#FFFFFF'
  });

  // "Step based icons" are not part of the official icon libarary. UX team suggests to create it using CSS.
  // The following style forms a base to create the progress step icons.
  export const stepIconBaseStyle: NestedCSSProperties = {
    height: 32,
    width: 32,
    left: 0,
    top: 0,
    borderRadius: 32,
    background: '#4F4F4F',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    order: 0,
    flexGrow: 0,
    marginTop: TabStyles.Spacing.LargeSpace
  };

  export const stepIconStyle = style({
      ...stepIconBaseStyle
  });

  export const stepIconDiabledStyle = style({
    ...stepIconBaseStyle,
    background: '#BFBFBF'
  });

  export const wordSpacingStyle= style({
    marginLeft: customDomainSpaceUnit
  });

  export const lineIconBaseStyle: React.CSSProperties = {
    marginLeft: TabStyles.Spacing.MediumSpace+3,
  };

  export const lineIconStyle: React.CSSProperties = {
      ...lineIconBaseStyle,
      borderLeft: '2px solid #4F4F4F',
      height: 80 /* adjust to desired height */
  };

export const subHeaderDisabledStyle: React.CSSProperties = {
  ...customDomainSubHeaderStyle,
  color:'#BFBFBF',
};

export const uploadedFileWidgetBaseStyle: React.CSSProperties = {
  background: '#F3F3F3',
  borderRadius: '2',
  display: 'flex',
  alignItems: 'center',
  padding: '4',
  width: '271px',
  height: '24px',
  flexDirection: 'row',
  position: 'relative'
};

export const uploadedFileTextStyle: React.CSSProperties = {
  fontFamily: 'Benton Sans',
  fontWeight: 'normal',
  fontSize: '14px',
  lineHeight: '17px',
  marginLeft: '10px'
};

export const fileUploadStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};

  export const customDomainWideField= style({
    ...wideWidth,
    // use nested styles to make the inputs match the parent's width, because the widget does not do that by default
    '$nest': {
      '& input': {
        ...wideWidth,
      },
    },
  });